<template>
  <div class="footer-copyright">
    <p>Copyright © {{ yearRange }} www.yesassess.com</p>
    <p>國際職業技能委員會版權所有 野原之森信息科技提供大陆区域技术支持</p>
    <p><a target="_blank" href="http://beian.miit.gov.cn">苏ICP备 19037999号-1</a></p>
  </div>
</template>

<script>
export default {
  name: 'Copyright',
  computed: {
    yearRange () {
      const range = [ 2019 ]
      range.push((new Date()).getFullYear())
      return Array.from(new Set(range)).join('-')
    }
  }
}
</script>

<style lang="less" scoped>
.footer-copyright {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 20px;
  line-height: 2;
  color: #fff;
  text-shadow: 1px 1px 1px #333;
  text-align: center;

  a {
    color: #fff !important;
    text-shadow: 1px 1px 1px #333;
  }
}
</style>
